import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { CsvReadFile } from 'src/AppState/PromotionQuestionsState/PromotionQuestionsState';
import { Input } from 'src/domains/common/components/input/input';
import { QuestionFormStateV2 } from './QuestionFormV2.state';
import { ButtonWrapper, QuestionFormV2Wrapper } from './QuestionFormV2.style';
import { Button } from 'src/domains/common/components/button/button';
import { UploaderV2 } from 'src/components/Uploader/UploaderV2/UploaderV2';

interface PropsType {
    isDisabled: boolean;
}

export const QuestionFormV2 = observer((props: PropsType) => {
    const { promotionQuestionsState } = useAppStateContext();
    const [state] = useState(() => new QuestionFormStateV2(promotionQuestionsState));
    const question = promotionQuestionsState.currentQuestion;

    const getFile = (): CsvReadFile | null => {
        if (state.questionFile !== null) {
            return state.questionFile;
        } else if (question === null) {
            return null;
        } else {
            return CsvReadFile.fromCsvReadItem(question);
        }
    };

    return (
        <QuestionFormV2Wrapper
            className='font-tertiary'
            isDisabled={props.isDisabled}
        >
            <h2 className='text-[1rem] font-semibold text-foreground leading-7 m-0 mb-1'>
                {question === null ? 'Create new' : 'Edit question'}
            </h2>

            <form
                className='flex flex-col relative'
                onSubmit={(e) => e.preventDefault()}
            >
                {/* <Loader isActive={state.isLoading} /> */}
                <Input
                    label='Campaign'
                    placeholder='Placeholder'
                    formInputState={state.questionV2}
                    description='max 90 characters'
                    errors={state.questionV2.errorsForView}
                    className='mb-4'
                />

                <UploaderV2
                    state={state.fileV2}
                    maxFileSize={state.maxFileSize}
                    allowedMimeTypes={state.allowedMimeTypes}
                    allowedFileTypes={state.allowedFileTypes}
                    file={getFile()}
                    onSelectFile={state.handleSelectFile}
                    onReplace={state.handleReplaceFile}
                    onRemove={state.handleRemoveFile}
                    uploadingFileName={state.questionFileName}
                    label='Upload CSV'
                    placeholder='Drag & Drop to upload CSV'
                />

                <ButtonWrapper>
                    <Button
                        className='mt-6 max-w-max'
                        variant='secondary'
                        onClick={() => state.handleCancel()}
                    >
                        Cancel
                    </Button>

                    <Button
                        disabled={state.isFormValid === false}
                        className='mt-6 max-w-max'
                        variant='primary'
                        onClick={() => state.handleSubmit()}
                    >
                        Create
                    </Button>
                </ButtonWrapper>

                {/* {Boolean(state.errorMessage) && <ErrorMessageBar>{state.errorMessage}</ErrorMessageBar>} */}
            </form>
        </QuestionFormV2Wrapper>
    );
});
